// Стажёр (deus_stazher, special) — EOT-trigger.
// Если на поле есть как минимум 3 Стажера → 1 случайный союзный юнит +1 броня.
// Срабатывает один раз на сторону за конец хода (не по каждому Стажёру).

export const CARD_ID = 'deus_stazher';

export function stazherEot(state, ownerIdx) {
  const p = state.players[ownerIdx];
  if (!p) return;
  const stazhery = p.unitsOnField().filter(u => u.id === CARD_ID);
  if (stazhery.length < 3) return;
  const allies = p.unitsOnField();
  if (allies.length === 0) return;
  const ally = allies[state.rng.int(allies.length)];
  ally.persistentArmor += 1;
  ally.persistentMaxArmor += 1;
  ally.current.armor += 1;
  state.log.add(`👥 Стажёры [${p.name}] (${stazhery.length}+): ${ally.name_ru} получает +1 брони (броня=${ally.armor})`);
}
